var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UndertakingDocuments.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7bdec0d6\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UndertakingDocuments.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Undertaking/UndertakingDocuments.vue
// module id = 837
// module chunks = 1